module.exports = __webpack_public_path__ + "static/multi-step-residential-a57dca5c75303c95cdc036545714d7ec.svg";